export const SET_SELECTED_STATUS_ACTION = 'selectedStatus';
export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_DATA_ENTRADA_INICIAL_ACTION = 'dataEntradaInicial';
export const SET_DATA_ENTRADA_FINAL_ACTION = 'dataEntradaFinal';
export const SET_COMPRADOR_ACTION = 'comprador';
